import { atom } from 'jotai';
import { FormSchema_V2, FormField_V2 } from '../../common/typescript/models/CollectFormV2';

/**
 * Current form being edited
 */
export const currentFormSchemaAtom = atom<FormSchema_V2>({
  fields: [],
  metadata: {
    version: '2.0.0',
    createdWith: 'GeoCloudWeb',
  },
});

/**
 * Form metadata (name, description)
 */
export const formMetadataAtom = atom<{
  name: string;
  description: string;
}>({
  name: '',
  description: '',
});

/**
 * Uploaded SQLite files (object names in MinIO)
 */
export const uploadedSqliteFilesAtom = atom<string[]>([]);

/**
 * Currently selected field for editing
 */
export const selectedFieldAtom = atom<FormField_V2 | null>(null);

/**
 * Field configuration drawer visibility
 */
export const fieldConfigDrawerVisibleAtom = atom<boolean>(false);

/**
 * Template UUID (when editing existing template)
 */
export const currentTemplateUuidAtom = atom<string | null>(null);

/**
 * Loading state
 */
export const formBuilderLoadingAtom = atom<boolean>(false);
